import React from 'react';
import {actions} from 'react-redux-form';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import {getCustomerNumbers} from './outlet';
import ToastMessage from '../components/common/toast-message';


const updateLevel = (payLoad, redirectUrl = '/admin/levels') => irelandApi.post('/api/admin/update_levels', {update_level: payLoad})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Level updated successfully"/>);
    store.dispatch(actions.reset('deep.admin_update_level'));
    store.dispatch(getCustomerNumbers('', '', true, true));
    history.push(redirectUrl);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during updating the level"/>);
    store.dispatch(actions.resetValidity('deep.admin_update_level'));
    const data = {
      ...error.response.data
    };
    return Promise.reject(data);
  });

export default updateLevel;



// WEBPACK FOOTER //
// ./src/actions/update-level.js